(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AddExamModalCtrl", ["examResource", "$localStorage", "$state", "_", "messageService", addExamModalCtrl]);
    function addExamModalCtrl(examResource, $localStorage, $state, _, messageService) {
        var vm = this;
        vm.state = "showForm";
        vm.enabledLocalizations = $localStorage.tenantSettings.enabledLocalizations;
        vm.formData = {
            name: "",
            description: "",
            localizationId: $localStorage.tenantSettings.defaultLocalization.id
        };
        vm.createExam = function () {
            if (vm.form.$valid) {
                vm.saving = true;
                examResource.save(vm.formData, function (result) {
                    vm.number = result.number;
                    vm.state = "showConfirmation";
                }, function (error) {
                    vm.saving = false;
                    messageService(error);
                });
            }
            else {
                vm.showErrors = true;
            }
        };
        //Clears form to be able to add another
        vm.createAnother = function () {
            vm.saving = false;
            vm.formData = {
                name: "",
                description: "",
                localizationId: $localStorage.tenantSettings.defaultLocalization.id
            };
            vm.state = "showForm";
            vm.showErrors = false;
        };
        vm.goToQuestions = function () {
            $state.go("main.learningItems.manageExamQuestions", { number: vm.number });
        };
        vm.goToCategories = function () {
            $state.go("main.learningItems.manageExamCategories", { number: vm.number });
        };
    }
}());
